<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'User Portfolio Allocation' }}</strong>
        </div>
        <div class="col-md-1 text-right">
          <span>
            <a class="btn btn-sm btn-small btn-warning" @click.prevent="userPortfolioAnalysis">
              <i title="User Portfolio Analysis" class="fa fa-line-chart cwhite"></i>
            </a>
          </span>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body user-profiling">
      <vue-tabs direction="horizontal" v-model="curTab" @tab-change="getTabData" active-text-color="black">
        <v-tab title="Zero New Cash" />
        <v-tab title="With New Cash" />
        <v-tab title="With New Cash and Portfolio Changes" />
      </vue-tabs>
      <div class="card txt-fmt" id="conversationForm">
        <form class="form-horizontal form-cs" @onsubmit.prevent action>
          <div class="d-flex mt-3">
            <div class="n-input-fl position-absolute">
              <tr>
                <td>
                  <label style="font-weight: 700;">New Cash Available:</label>
                </td>
                <td class="pl-2 pr-4">
                  <input class="new-tbl-cs" type="text" v-model="nCashAvailableVal" />
                </td>
                <button type="button" class="btn btn-info" @click="nCaseAvailableSubmit">Submit</button>
              </tr>
            </div>
            <div class="w-100 m-2 pb-2 text-right">
              <button @click="updateCronData" type="button" class="btn btn-success">Update</button>
            </div>
          </div>
          <div>
            <table class="table table-bordered fonts11 app-inner" style="table-layout:fixed;">
              <tr v-for="(tab, index) in tabsData" v-bind:key="'tab' + index">
                <th v-if="tab.value === 'portfolio_allocation'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Variables:</th>
                              <th>To be filled</th>
                            </tr>
                          </thead>
                          <tbody v-if="userPortfolioAllocationData.length > 0">
                            <div v-for="(itemLbl, subIdx) in portfolioAllocationLblData" :key="subIdx"
                              style="display: contents;">
                              <tr v-for="(key, index) in userPortfolioAllocationData" :key="index">
                                <td>
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td>
                                  <v-select v-if="itemLbl.list" :options="itemLbl.list" :placeholder="''"
                                    v-model="key[itemLbl.field]" style="margin-left:0; font-weight: normal;">
                                  </v-select>
                                  <input v-else-if="key.client_id" class="new-tbl-cs" type="text"
                                    v-model="key[itemLbl.field]" />
                                  <input v-else class="new-tbl-cs" type="text" v-model="itemLbl.value" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitPortfolioAllocationData">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'desired_asset_allocation_client'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table v-if="desireAssetAllocationTblData.length > 0"
                          class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in desireAssetAllocationLblData" :key="index"
                                :style="[item.field === 'desired_asset_field' ? { 'width': '40%' } : { 'width': 'auto', 'text-align': 'right' }]">
                                {{ item.lbl }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(key, index) in desireAssetAllocationTblData[0].data" :key="index">
                              <td v-for="(itemLbl, subIdx) in desireAssetAllocationLblData" :key="subIdx">
                                <input v-if="itemLbl.field == 'desired_asset_field' || itemLbl.field == '%_Mix'"
                                  :class="{ 'new-tbl-cs': true, 'text-right': itemLbl.field == '%_Mix' }" type="text"
                                  v-model="key[itemLbl.field]" />
                                <label v-else>{{ key[itemLbl.field] }}</label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  <strong>Total</strong>
                                </label>
                              </td>
                              <td class="text-right">
                                {{
                                  desireAssetAllocationTotal(desireAssetAllocationTblData[0].data)
                                }}%
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitDesireAssetAllocationAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'desired_alternatives_allocation_client'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive001 scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in desiredMixAlternativesLblData" :key="index"
                                :style="[item.field === 'desired_asset_field' ? { 'width': '40%' } : { 'width': 'auto', 'text-align': 'right' }]">
                                {{ item.lbl }}
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="desiredMixAlternativesTblData.length > 0">
                            <tr v-for="(key, index) in desiredMixAlternativesTblData[0].data" :key="index">
                              <td v-for="(itemLbl, subIdx) in desiredMixAlternativesLblData" :key="subIdx"
                                class="align-middle">
                                <label v-if="itemLbl.field === 'desired_asset_field'">{{ key[itemLbl.field] }}</label>
                                <input v-else class="new-tbl-cs text-right" type="text" v-model="key[itemLbl.field]" />
                              </td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td class="text-right">
                                <label class="font-weight-bold" v-if="desiredMixAlternativesTblData.length > 0">{{
                                  desiredMixAlternativesTblData[0].total_value }}%</label>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-0">
                        <button type="button" class="btn btn-info"
                          @click="submitDesiredMixAlternativesAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'asset_class'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive001 scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in assetClassLblData" :key="index"
                                :style="[item.field === 'asset_class_field' ? { 'width': '40%' } : { 'width': 'auto', 'text-align': 'right' }]">
                                {{ item.lbl }}
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="assetClassTblData.length > 0">
                            <tr v-for="(key, index) in assetClassTblData[0].data" :key="index">
                              <td v-for="(itemLbl, subIdx) in assetClassLblData" :key="subIdx" class="align-middle">
                                <label v-if="itemLbl.field === 'asset_class_field'">{{ key[itemLbl.field] }}</label>
                                <input v-else class="new-tbl-cs text-right" type="text" v-model="key[itemLbl.field]" />
                              </td>
                            </tr>
                            <tr>
                              <td class="align-middle">Total</td>
                              <td class="text-right">
                                <input class="new-tbl-cs border-0 font-weight-bold text-right"
                                  v-if="assetClassTblData.length > 0" v-model="assetClassTblData[0].total_value"
                                  readonly></input>
                              </td>
                              <td class="text-right">
                                <label
                                  class="new-tbl-cs border-0 font-weight-bold d-flex align-items-center justify-content-end">{{
                                    (assetClassTblData[0].total_value_persentage).toFixed(2) }}%</label>
                              </td>
                              <!-- <td class="text-right">
                                <label
                                  class="new-tbl-cs border-0 font-weight-bold d-flex align-items-center justify-content-end">{{
                                    (assetClassTblData[0].total_value_persentage_without_new_cash).toFixed(2) }}%</label>
                              </td> -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-0">
                        <button type="button" class="btn btn-info" @click="submitAssetClassAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'alternatives_inr'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive001 scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in allocationAlternativesInrLblData" :key="index"
                                :style="[item.field === 'asset_class_field' ? { 'width': '40%' } : { 'width': 'auto', 'text-align': 'right' }]">
                                {{ item.lbl }}
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="allocationAlternativesInrTblData.length > 0">
                            <tr v-for="(key, index) in allocationAlternativesInrTblData[0].data" :key="index">
                              <td v-for="(itemLbl, subIdx) in allocationAlternativesInrLblData" :key="subIdx"
                                class="align-middle">
                                <label v-if="itemLbl.field === 'asset_class_field'">{{ key[itemLbl.field] }}</label>
                                <input v-else class="new-tbl-cs text-right" type="text" v-model="key[itemLbl.field]" />
                              </td>
                            </tr>
                            <tr>
                              <td class="align-middle">Total</td>
                              <td>
                                <input class="new-tbl-cs border-0 font-weight-bold text-right"
                                  v-if="allocationAlternativesInrTblData.length > 0"
                                  v-model="allocationAlternativesInrTblData[0].total_value" readonly></input>
                              </td>
                              <td>
                                <label
                                  class="new-tbl-cs border-0 font-weight-bold d-flex align-items-center justify-content-end">{{
                                    allocationAlternativesInrTblData[0].total_value_persentage }}%</label>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-0">
                        <button type="button" class="btn btn-info" @click="submitAlternativesInrAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'actual_portfolio_analysis'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Actual portfolio analysis:</th>
                              <th class="text-right">To be filled</th>
                              <th class="text-right">To be filled Manually</th>
                            </tr>
                          </thead>
                          <tbody v-if="userProfileAllocationReportAllTblData.actual_portfolio_analysis">
                            <div v-for="(itemLbl, subIdx) in actualPortfolioAnalysisLblData" :key="subIdx"
                              style="display: contents;">
                              <!-- <tr v-for="(key, index) in userProfileAllocationReportAllTblData.actual_portfolio_analysis" :key="index"> -->
                              <tr>
                                <!-- { lbl: "Stock Portfolio Value", field: "stock_portfolio_value", col1: "stock_portfolio_value", col2: "stock_portfolio_value_manual" }, -->
                                <td>
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td>
                                  <!-- <input class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" /> -->
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.actual_portfolio_analysis[itemLbl.field][itemLbl.col1]"
                                    readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.actual_portfolio_analysis[itemLbl.field][itemLbl.col2]" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'individual_stock_investments'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in indivStockInvestmentsLblData" :key="index"
                                :style="[item.field === 'name' ? { 'width': '40%' } : { 'width': 'auto' }]"
                                class="align-middle">
                                {{ item.lbl }}
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody v-if="indivStockInvestmentsTblData.List_of_all_individual_stock_investments">
                            <tr
                              v-for="(key, index) in indivStockInvestmentsTblData.List_of_all_individual_stock_investments"
                              :key="index">
                              <td
                                :class="{ 'text-right': itemLbl.field !== 'name_of_stock' && itemLbl.field !== 'sectorname' && itemLbl.field !== 'industry_type' }"
                                v-for="(itemLbl, subIdx) in indivStockInvestmentsLblData" :key="subIdx"
                                class="align-middle">
                                <label v-if="itemLbl.field === 'name_of_stock' || itemLbl.field === 'sectorname'">{{
                                  key[itemLbl.field] }}</label>
                                <label v-else>{{
                                  itemLbl.field === 'latest_value_per_all_values_of_company%' ? key[itemLbl.field] :
                                    key[itemLbl.field] }}</label>
                              </td>
                              <td class="align-middle"><a class="btn btn-sm btn-small btn-danger"
                                  @click="submitIndivStockInvestmentsAPI(index)"><i title="Delete Row"
                                    class="fa fa-trash cwhite"></i></a></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td class="text-right">
                                {{ indivStockInvestmentsTblData.total_latest_value }}
                              </td>
                              <td class="text-right">
                                {{ indivStockInvestmentsTblData.total_latest_value_pr }}%
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- <div class="form-group d-flex justify-content-start mb-0 pt-0">
                        <button type="button" class="btn btn-info" @click="submitIndivStockInvestmentsAPI">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'sector_mix'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Sector Mix</th>
                              <th class="text-right">Amount</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody v-if="userProfileAllocationReportAllTblData.Sector_Mix">
                            <div style="display: contents;">
                              <tr v-for="(obj, subIdx) in userProfileAllocationReportAllTblData.Sector_Mix.Sector_Mix"
                                :key="subIdx">
                                <td>
                                  <label>{{ obj.sectorname }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj.amount" readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="obj.latest_value_per_all_values_of_company" readonly />
                                </td>
                              </tr>
                              <tr>
                                <td>Total</td>
                                <td class="text-right" v-if="userProfileAllocationReportAllTblData.Sector_Mix">
                                  {{ userProfileAllocationReportAllTblData.Sector_Mix.total_amount }}
                                </td>
                                <td class="text-right" v-if="userProfileAllocationReportAllTblData.Sector_Mix">
                                  {{ userProfileAllocationReportAllTblData.Sector_Mix.total_latest_value_per }}%
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'market_cap_mix'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Market cap Mix</th>
                              <th class="text-right">Amount</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody v-if="userProfileAllocationReportAllTblData.marker_cap_wise">
                            <div style="display: contents;">
                              <tr
                                v-for="(obj, subIdx) in userProfileAllocationReportAllTblData.marker_cap_wise.marker_cap_wise"
                                :key="subIdx">
                                <td>
                                  <label>{{ (Object.keys(obj)[0]).toUpperCase() }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="obj[Object.keys(obj)[0]].amount" readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="obj[Object.keys(obj)[0]].latest_value_per_all_values_of_company"
                                    readonly />
                                </td>
                              </tr>
                              <tr>
                                <td>Total</td>
                                <td class="text-right" v-if="userProfileAllocationReportAllTblData.marker_cap_wise">
                                  {{ userProfileAllocationReportAllTblData.marker_cap_wise.total_amount }}
                                </td>
                                <td class="text-right" v-if="userProfileAllocationReportAllTblData.marker_cap_wise">
                                  {{ userProfileAllocationReportAllTblData.marker_cap_wise.total_latest_value_per }}%
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'individual_mf_investments'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in indivMFInvestmentsLblData" :key="index"
                                :style="[item.field === 'sch_name' ? { 'width': '15%' } : { 'width': 'auto' }]"
                                class="align-middle">
                                {{ item.lbl }}
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody v-if="indivMFInvestmentsTblData.List_of_all_individual_MF_investments">
                            <tr v-for="(key, index) in indivMFInvestmentsTblData.List_of_all_individual_MF_investments"
                              :key="index">
                              <td
                                :class="{ 'text-right': itemLbl.field !== 'sch_name' && itemLbl.field !== 'MainCategory' && itemLbl.field !== 'Category' && itemLbl.field !== 'Name_AMC' && itemLbl.field !== 'FundManager' && itemLbl.field !== 'Recommended' && itemLbl.field !== 'Duration_Yrs' }"
                                v-for="(itemLbl, subIdx) in indivMFInvestmentsLblData" :key="subIdx"
                                class="align-middle">
                                <label
                                  v-if="itemLbl.field === 'sch_name' || itemLbl.field === 'Name_AMC' || itemLbl.field === 'MainCategory' || itemLbl.field === 'Category' || itemLbl.field === 'FundManager'">{{
                                    key[itemLbl.field] }}</label>
                                <label class="text-right" v-else>{{ itemLbl.field === 'lv_by_total_%' ?
                                  key[itemLbl.field] : key[itemLbl.field] }}</label>
                              </td>
                              <td class="align-middle"><a class="btn btn-sm btn-small btn-danger"
                                  @click="submitIndivMFInvestmentsAPI(index)"><i title="Delete Row"
                                    class="fa fa-trash cwhite"></i></a></td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td class="text-right">{{
                                indivMFInvestmentsTblData.total_latest_value }}</td>
                              <td class="text-right">
                                {{ indivMFInvestmentsTblData.total_latest_value_pr }}%
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'amc_wise_exposure'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>AMC wise exposure</th>
                              <th class="text-right">INR</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="userProfileAllocationReportAllTblData.AMC_wise_exposure">
                              <tr
                                v-for="(obj, subIdx) in userProfileAllocationReportAllTblData.AMC_wise_exposure.AMC_wise_exposure"
                                :key="subIdx">
                                <td>
                                  <label>{{ obj.Name_AMC }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj.Total_latest_value"
                                    readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="obj['latest_value_per_all_values_of_company']" readonly />
                                </td>
                              </tr>
                              <tr>
                                <td>Total</td>
                                <td class="text-right" v-if="userProfileAllocationReportAllTblData.AMC_wise_exposure">
                                  <input class="new-tbl-cs text-right text-bold border-0" type="text"
                                    v-model="userProfileAllocationReportAllTblData.AMC_wise_exposure.total_value"
                                    readonly />
                                </td>
                                <td class="text-right"><input class="new-tbl-cs text-right text-bold border-0"
                                    type="text"
                                    v-model="userProfileAllocationReportAllTblData.AMC_wise_exposure.total_latest_value_per"
                                    readonly /></td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'fund_manager_wise_exposure'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Fund Manager wise exposure</th>
                              <th class="text-right">INR</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="userProfileAllocationReportAllTblData.Fund_Manager_wise_exposure">
                              <tr
                                v-for="(obj, subIdx) in userProfileAllocationReportAllTblData.Fund_Manager_wise_exposure.Fund_Manager_wise_exposure"
                                :key="subIdx">
                                <td>
                                  <label>{{ obj.FundManager }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj.Total_latest_value"
                                    readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="obj['latest_value_per_all_values_of_company']" readonly />
                                </td>
                              </tr>
                            </div>
                            <tr v-if="userProfileAllocationReportAllTblData.Fund_Manager_wise_exposure">
                              <td>Total</td>
                              <td class="text-right"><input class="new-tbl-cs text-right text-bold border-0" type="text"
                                  v-model="userProfileAllocationReportAllTblData.Fund_Manager_wise_exposure.total_value"
                                  readonly /></td>
                              <td><input class="new-tbl-cs text-right text-bold border-0" type="text"
                                  v-model="userProfileAllocationReportAllTblData.Fund_Manager_wise_exposure.total_latest_value_per"
                                  readonly /></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'mf_portfolio_summary_categorywise'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Category</th>
                              <th class="text-right">Amount</th>
                              <th class="text-right">Weight (%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;" v-if="userProfileAllocationReportAllTblData.categorywise">
                              <tr
                                v-for="(obj, subIdx) in userProfileAllocationReportAllTblData.categorywise.categorywise"
                                :key="subIdx">
                                <td>
                                  <label>{{ obj.Category }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj.Amount" readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj['Weight (%)']"
                                    readonly />
                                </td>
                              </tr>
                            </div>
                            <tr v-if="userProfileAllocationReportAllTblData.categorywise">
                              <td>Total</td>
                              <td class="text-right">{{
                                userProfileAllocationReportAllTblData.categorywise.total_value }}
                              </td>
                              <td class="text-right">{{
                                (userProfileAllocationReportAllTblData.categorywise.categorywise_total).toString() }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'mf_portfolio_summary_main_categorywise'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Category</th>
                              <th class="text-right">Amount</th>
                              <th class="text-right">Weight (%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div style="display: contents;"
                              v-if="userProfileAllocationReportAllTblData.maincategorywise">
                              <tr
                                v-for="(obj, subIdx) in userProfileAllocationReportAllTblData.maincategorywise.maincategorywise"
                                :key="subIdx">
                                <td>
                                  <label>{{ obj.MainCategory }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj.Amount" readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text" v-model="obj['Weight (%)']"
                                    readonly />
                                </td>
                              </tr>
                            </div>
                            <tr v-if="userProfileAllocationReportAllTblData.maincategorywise">
                              <td>Total</td>
                              <td class="text-right">{{
                                userProfileAllocationReportAllTblData.maincategorywise.total_value }}
                              </td>
                              <td class="text-right">{{
                                userProfileAllocationReportAllTblData.maincategorywise.maincategorywise_total }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'equity_inr'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Equity</th>
                              <th class="text-right">INR</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-for="(itemLbl, subIdx) in equityInrLblData" :key="subIdx" style="display: contents;">
                              <tr v-if="userProfileAllocationReportAllTblData.equity">
                                <td>
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.equity[itemLbl.field][itemLbl.field]"
                                    readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.equity[itemLbl.field]['%']"
                                    readonly />
                                </td>
                              </tr>
                            </div>
                            <tr v-if="userProfileAllocationReportAllTblData.equity">
                              <td>Total</td>
                              <td class="text-right">{{ userProfileAllocationReportAllTblData.equity.total_value }}</td>
                              <td class="text-right">{{
                                userProfileAllocationReportAllTblData.equity.total_equity_percentage }}%</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'debt_inr'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Debt</th>
                              <th class="text-right">INR</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-for="(itemLbl, subIdx) in debtInrLblData" :key="subIdx" style="display: contents;">
                              <tr v-if="userProfileAllocationReportAllTblData.Debt">
                                <td>
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.Debt[itemLbl.field][itemLbl.sub_field]"
                                    readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.Debt[itemLbl.field]['%']" readonly />
                                </td>
                              </tr>
                            </div>
                            <tr v-if="userProfileAllocationReportAllTblData.Debt">
                              <td>Total</td>
                              <td class="text-right">{{ userProfileAllocationReportAllTblData.Debt.total_value }}</td>
                              <td class="text-right">{{ userProfileAllocationReportAllTblData.Debt.total_debt_percentage
                              }}%
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'large_cap'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Large cap</th>
                              <th class="text-right">INR</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-for="(itemLbl, subIdx) in largeCapLblData" :key="subIdx" style="display: contents;">
                              <tr v-if="userProfileAllocationReportAllTblData.Large_cap">
                                <td>
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.Large_cap[itemLbl.field][itemLbl.sub_field]"
                                    readonly />
                                </td>
                                <td>
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.Large_cap[itemLbl.field]['%']"
                                    readonly />
                                </td>
                              </tr>
                            </div>
                            <tr v-if="userProfileAllocationReportAllTblData.Large_cap">
                              <td>Total</td>
                              <td class="text-right">{{ userProfileAllocationReportAllTblData.Large_cap.total_value }}
                              </td>
                              <td class="text-right">{{
                                userProfileAllocationReportAllTblData.Large_cap.total_large_cap_percentage }}%</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'stock_portfolio_report'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive001 scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th class="align-middle">Stock Portfolio report</th>
                              <th class="align-middle">Limit</th>
                            </tr>
                          </thead>
                          <tbody v-if="stockPortfolioReportTblData.length != 0">
                            <tr v-for="(key, index) in stockPortfolioReportLblData" :key="index">
                              <td class="align-middle">
                                <label>{{ key.lbl }}</label>
                              </td>
                              <td class="align-middle">
                                <input v-if="key.hasChild.length === 0 && key.childFiled.length == 0" class="new-tbl-cs"
                                  type="text" v-model="stockPortfolioReportTblData[key.field]" />
                                <input v-else-if="key.hasChild.length === 0 && key.childFiled.length > 0"
                                  class="new-tbl-cs" type="text"
                                  v-model="stockPortfolioReportTblData[key.field][key.childFiled]" />
                                <table v-else class="table table-bordered fonts11 app-inner mb-0">
                                  <tbody v-if="stockPortfolioReportTblData[key.field]"
                                    v-for="(child, subIdx) in stockPortfolioReportTblData[key.field]">
                                    <tr>
                                      <td class="align-middle w-50">
                                        <label>{{ child[key.hasChild[0]] }}</label>
                                      </td>
                                      <td class="align-middle w-auto"><input class="new-tbl-cs" type="text"
                                          v-model="child[key.hasChild[1]]" /></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'mf_portfolio_report'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive001 scrollbar app" v-dragscroll="true">
                        <table v-if="curTab === 'Zero New Cash'" class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th class="align-middle">Mutual Fund Portfolio report</th>
                              <th class="align-middle">Limit</th>
                            </tr>
                          </thead>
                          <tbody v-if="mfPortfolioReportTblData.hasOwnProperty('number_of_schemes')">
                            <tr v-for="(key, index) in mfPortfolioReportLblData" :key="index">
                              <td class="align-middle">
                                <label>{{ key.lbl }}</label>
                              </td>
                              <td class="align-middle" v-if="key.field == 'top_holdings'">
                                <div v-for="(child, childIdx) in Object.keys(mfPortfolioReportTblData[key.field])">
                                  <table v-if="key.filed1 === child" class="w-100">
                                    <tbody>
                                      <tr v-for="(sub, subIdx) in mfPortfolioReportTblData[key.field][child]">
                                        <td class="align-middle w-50">
                                          <label>{{ child == 'Scheme' ? sub.sch_name : sub[child] }}</label>
                                        </td>
                                        <td class="align-middle w-auto"><input class="new-tbl-cs" type="text"
                                            v-model="sub.latest_value_by_total_value" />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                              <td
                                v-else-if="key.field == 'top_3_scheme_holdings' || key.field == 'less_than_1_percent_holdings'">
                                <table class="w-100">
                                  <tbody>
                                    <tr v-for="(scheme, schemeIdx) in mfPortfolioReportTblData[key.field]">
                                      <td class="align-middle w-50">
                                        <label>{{ scheme.sch_name }}</label>
                                      </td>
                                      <td class="align-middle w-auto"><input class="new-tbl-cs" type="text"
                                          v-model="scheme.latest_value_by_total_value" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td v-else-if="key.field === 'top_3_holding'">
                                <!-- mfPortfolioReportTblData[key.field] -->
                                <input class="new-tbl-cs" type="text" v-model="mfPortfolioReportTblData[key.field]" />
                              </td>
                              <td v-else-if="key.field == 'large_cap_holding'">
                                <table class="w-100">
                                  <tbody>
                                    <tr v-for="(scheme, schemeIdx) in mfPortfolioReportTblData[key.field]">
                                      <td class="align-middle w-50">
                                        <label>{{ scheme.sch_name }}</label>
                                      </td>
                                      <td class="align-middle w-auto"><input class="new-tbl-cs" type="text"
                                          v-model="scheme['Large_Cap_holding%']" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td v-else-if="key.field == 'beta' || key.field == 'small_cap_funds'">
                                <table class="w-100">
                                  <tbody>
                                    <tr v-for="(scheme, schemeIdx) in mfPortfolioReportTblData[key.field]['schemes']">
                                      <td class="align-middle w-50">
                                        <label>{{ scheme.sch_name }}</label>
                                      </td>
                                      <td class="align-middle w-auto"><input class="new-tbl-cs" type="text"
                                          v-model="scheme.latest_value_by_total_value" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td v-else-if="key.filed1.length == 0">
                                <input class="new-tbl-cs" type="text" v-model="mfPortfolioReportTblData[key.field]" />
                              </td>
                              <td v-else-if="key.filed1.length > 0 && key.hasChild.length === 0">
                                <input class="new-tbl-cs" type="text"
                                  v-model="mfPortfolioReportTblData[key.field][key.filed1]" />
                              </td>
                              <td v-else>
                                <table v-if="key.filed1 == 'sectors_greater_than_30'" class="w-100">
                                  <tbody>
                                    <tr
                                      v-for="(scheme, schemeIdx) in mfPortfolioReportTblData[key.field][key.filed1]['sectors_greater_than_30']">
                                      <td class="align-middle w-50">
                                        <label>{{ scheme.sector_name }}</label>
                                      </td>
                                      <td class="align-middle w-auto"><input class="new-tbl-cs" type="text"
                                          v-model="scheme.consol_perc_hldg" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <input v-else class="new-tbl-cs" type="text"
                                  v-model="mfPortfolioReportTblData[key.field][key.filed1][key.hasChild[1]]" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- =================================== -->
                        <!-- START: With New Cash || With New Cash and Portfolio Changes -->
                        <!-- =================================== -->
                        <table v-if="curTab === 'With New Cash' || curTab === 'With New Cash and Portfolio Changes'"
                          class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th class="align-middle">Mutual Fund Portfolio report</th>
                              <th class="align-middle">Limit</th>
                            </tr>
                          </thead>
                          <tbody v-if="mfPortfolioReportTblData">
                            <tr v-if="mfPortfolioReportTblData.hasOwnProperty('number_of_schemes')"
                              v-for="(key, index) in mfPortfolioReportLblTab2Data" :key="index">
                              <td class="align-middle">
                                <label>{{ key.lbl }}</label>
                              </td>
                              <td v-if="key.filed1 !== '' && key.hasChild.length === 0">
                                <input class="new-tbl-cs" type="text"
                                  v-model="mfPortfolioReportTblData[key.field][key.filed1]" />
                              </td>
                              <td v-else>
                                <div v-if="key.hasChild.length > 0" class="w-100">
                                  <div v-for="(scheme3, childIdx) in mfPortfolioReportTblData[key.field]">
                                    <table class="w-100">
                                      <tbody>
                                        <tr>
                                          <td class="align-middle w-50">
                                            <label>{{ scheme3[key.hasChild[0]] }}</label>
                                          </td>
                                          <td class="align-middle w-auto"><input class="new-tbl-cs" type="text"
                                              v-model="scheme3[key.hasChild[1]]" />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <input v-else-if="key.filed1 !== ''" class="new-tbl-cs" type="text"
                                  v-model="mfPortfolioReportTblData[key.field][key.filed1]" />
                                <input v-else class="new-tbl-cs" type="text"
                                  v-model="mfPortfolioReportTblData[key.field]" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- =================================== -->
                        <!-- END: With New Cash || With New Cash and Portfolio Changes -->
                        <!-- =================================== -->
                      </div>
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'asset_class_outlook_and_action'" style="background-color: white;"><a
                    class="btn btn-sm" @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div class="table-responsive scrollbar app" v-dragscroll="true">
                        <table class="table table-bordered fonts11 app-inner">
                          <thead>
                            <tr>
                              <th v-for="(item, index) in outlookAndActionLblData" :key="index"
                                :style="[item.field === 'field_name' ? { 'width': '30%' } : { 'width': 'auto' }]"
                                class="align-middle">
                                {{ item.lbl }}
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="outlookAndActionTblData.length > 0">
                            <tr v-for="(key, index) in outlookAndActionTblData[0].data" :key="index">
                              <td v-for="(itemLbl, subIdx) in outlookAndActionLblData" :key="subIdx"
                                class="align-middle">
                                <label v-if="itemLbl.field === 'field_name'">{{
                                  key[itemLbl.field] }}</label>
                                <input v-else class="new-tbl-cs" type="text" v-model="key[itemLbl.field]" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Disable button (5-5-2025) as per Nimesh say -->
                      <!-- <div class="form-group d-flex justify-content-between">
                        <button type="button" class="btn btn-info" @click="submitOutlookAndActionAPI">Submit</button>
                      </div> -->
                    </form>
                  </div>
                </th>
                <th v-if="tab.value === 'actual_exposure'" style="background-color: white;"><a class="btn btn-sm"
                    @click="showDetails(tab)"><b>{{ tab.name }}</b></a>
                  <div v-show="tab.show" class="pt-3">
                    <form class="form-horizontal form-cs-n" @onsubmit.prevent action>
                      <div>
                        <table style="width:100%;background-color:white;">
                          <thead>
                            <tr>
                              <th>Actual exposure</th>
                              <th>Name</th>
                              <th class="text-right">INR</th>
                              <th class="text-right">%</th>
                            </tr>
                          </thead>
                          <tbody>
                            <div v-for="(itemLbl, subIdx) in actualExposureLblData" :key="subIdx"
                              v-if="userProfileAllocationReportAllTblData.Actual_exposure" style="display: contents;">
                              <tr v-if="itemLbl.field === 'AAA_debt'">
                                <td class="align-middle">
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td colspan="3" style="padding: 0 !important;">
                                  <table style="width:100%;">
                                    <tbody>
                                      <tr
                                        v-for="(aaaDebt, childIdx) in userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field]"
                                        v-if="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field]"
                                        :key="childIdx">
                                        <td class="align-middle w-auto">
                                          <label>{{ aaaDebt.sch_name }}</label>
                                        </td>
                                        <td class="align-middle w-auto">
                                          <input class="new-tbl-cs text-right" type="text"
                                            v-model="aaaDebt['latest_value']" />
                                        </td>
                                        <td class="align-middle w-auto">
                                          <input class="new-tbl-cs text-right" type="text"
                                            v-model="aaaDebt['AAA_holding%']" />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr v-else-if="itemLbl.field === 'Duration'">
                                <td class="align-middle">
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td colspan="3" style="padding: 0 !important;">
                                  <table style="width:100%;">
                                    <tbody>
                                      <tr
                                        v-for="(aaaDebt, childIdx) in userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field]"
                                        v-if="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field]"
                                        :key="childIdx">
                                        <td class="align-middle w-auto">
                                          <label>{{ aaaDebt.sch_name }}</label>
                                        </td>
                                        <td class="align-middle w-auto">
                                          <input class="new-tbl-cs text-right" type="text"
                                            v-model="aaaDebt['latest_value']" />
                                        </td>
                                        <td class="align-middle w-auto">
                                          <input class="new-tbl-cs text-right" type="text"
                                            v-model="aaaDebt['Duration_Yrs']" />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr v-else-if="itemLbl.field === 'Expense_ratio_actual'">
                                <td class="align-middle">
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td colspan="3" style="padding: 0 !important;"
                                  v-if="Array.isArray(userProfileAllocationReportAllTblData.Actual_exposure['Expense_ratio_actual'])">
                                  <table style="width:100%;">
                                    <tbody>
                                      <tr
                                        v-for="(expenseRatio, childIdx) in userProfileAllocationReportAllTblData.Actual_exposure['Expense_ratio_actual']"
                                        :key="childIdx">
                                        <td class="align-middle w-auto">
                                          <label>{{ expenseRatio.sch_name }}</label>
                                        </td>
                                        <td class="align-middle w-auto">
                                          <input class="new-tbl-cs text-right" type="text"
                                            v-model="expenseRatio['latest_value']" />
                                        </td>
                                        <td class="align-middle w-auto">
                                          <input class="new-tbl-cs text-right" type="text"
                                            v-model="expenseRatio['Expense_ratio%']" />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <div v-else-if="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field]"
                                  style="display: contents;">
                                  <td class="align-middle">
                                    <label v-if="itemLbl.name !== ''">{{
                                      userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field][itemLbl.name]
                                    }}</label>
                                  </td>
                                  <td class="align-middle">
                                    <input v-if="itemLbl.sub_field === ''" class="new-tbl-cs text-right" type="text"
                                      v-model="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field]" />
                                    <input v-else class="new-tbl-cs text-right" type="text"
                                      v-model="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field][itemLbl.sub_field]" />
                                  </td>
                                  <td class="align-middle">
                                    <input class="new-tbl-cs text-right" type="text"
                                      v-model="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field][itemLbl.third_field]" />
                                  </td>
                                </div>
                              </tr>
                              <tr v-else-if="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field]">
                                <td class="align-middle">
                                  <label>{{ itemLbl.lbl }}</label>
                                </td>
                                <td class="align-middle">
                                  <label v-if="itemLbl.name !== ''">{{
                                    userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field][itemLbl.name]
                                  }}</label>
                                </td>
                                <td class="align-middle">
                                  <input v-if="itemLbl.sub_field === ''" class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field]" />
                                  <input v-else class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field][itemLbl.sub_field]" />
                                </td>
                                <td class="align-middle">
                                  <input class="new-tbl-cs text-right" type="text"
                                    v-model="userProfileAllocationReportAllTblData.Actual_exposure[itemLbl.field][itemLbl.third_field]" />
                                </td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group d-flex justify-content-start mb-0 pt-3">
                        <button type="button" class="btn btn-info"
                          @click="submitUserProfileAllocationReportAllAPI">Submit</button>
                      </div>
                    </form>
                  </div>
                </th>
              </tr>
            </table>
          </div>
        </form>
      </div>

      <div class="clear-fix"></div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import Datepicker from "vuejs-datepicker";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: { Datepicker },
  mixins: [commonMixins],
  name: "UserProfiling",
  props: ["user"],
  created() {
    console.log('user-profiling >> this.$route.params', this.$route.params)
    this.userId = parseFloat(this.$route.params.id);
    this.curTabIndex = this.$route.query.tab;
    console.log("user-profiling >> ::: Route Tab id", this.curTabIndex);
    this.isIntFirstTime = true;

    if (this.curTabIndex == 0) {
      this.curTab = 'Zero New Cash';
    } else if (this.curTabIndex == 1) {
      this.curTab = 'With New Cash';
    } else if (this.curTabIndex == 2) {
      this.curTab = 'With New Cash and Portfolio Changes';
    } else {
      this.curTab = 'Zero New Cash';
      this.curTabIndex = 0;
    }


    this.getPortfolioAllocationData();
    this.getDesireAssetAllocationAPI();
    this.getAssetClassAPI();
    this.getAlternativesInrAPI();
    this.getDesiredMixAlternativesAPI();
    //For all table in one api
    this.getUserProfileAllocationReportAllAPI();
    //For all table in one api
    this.getIndivStockInvestmentsAPI();
    this.getIndivMFInvestmentsAPI();
    this.getOutlookAndActionAPI();

    this.getStockPortfolioReportAPI();
    this.getMfPortfolioReportAPI();
  },
  /* watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  }, */
  /* watch: {
    equity(newX) {
      console.log('newX', newX)
    }
  }, */

  data() {
    return {
      isIntFirstTime: true,
      cutTab: "Strategy",
      curTab: "Zero New Cash",
      curTabIndex: 0,
      userId: null,
      apiUrl: "frontend/getStockUserDetails",
      retirementFormData: [{ "data": [] }],
      nCashAvailableVal: 0,
      strategyMasterData: [],
      selectedCategoryItem: null,
      ifIsBlank: false,
      categoryMasterData: [],
      usersStrategyForm: [],
      otherTabs: { summary: true, hubble: true, aaa: true, time_horizon: true, risk_profile: true, income_generation: true, professionals_recommendation: true },
      grableTreeFactorData: {},
      interpretationResults: {},
      firstInvestmentTblData: [],
      /* NEW DATA: START */
      userPortfolioAllocationData: [],
      portfolioAllocationLblData: [
        { lbl: "Taxation status", field: "taxation_status", list: ["Resident", "NRI", "XXX"] },
        { lbl: "Risk Tolerance / Investor Profile", field: "risk_tolerance_investor_profile", list: ["Conservative Income", "Medium to high risk tolerance", "Aggressive"] },
        { lbl: "Investor risk profile (more refined)", field: "investor_risk_profile", list: ["Very Cautious Investor", "Cautious Investor", "Moderate Investor", "Aggressive Investor", "Very Aggressive Investor"] },
        { lbl: "Risk need", field: "risk_need", value: "Mod" },
        { lbl: "Risk-taking ability", field: "risk_taking_ability", value: "Mod" },
        { lbl: "Behavioral loss tolerance", field: "behavioral_loss_tolerance", value: "Mod" },
        { lbl: "Green/Yellow/Red Light", field: "green_yellow_red_light", value: "Green Light" },
        { lbl: "Financial consequence", field: "financial_consequence" },
        { lbl: "Investing experience", field: "investing_experience", list: ["Low", "Medium", "High"] },
        { lbl: "Recommendation", field: "recommendation", value: "Moderate" },
        { lbl: "Strategy", field: "strategy", value: "Directly Implement" },
        { lbl: "Investing Experience Brief", field: "investing_experience_brief" },
      ],
      tabsData: [
        { name: "Portfolio Allocation", value: "portfolio_allocation", show: false },
        { name: "Desired Asset Allocation (Client)", value: "desired_asset_allocation_client", show: false },
        { name: "Alternatives Desired Mix", value: "desired_alternatives_allocation_client", show: false },
        { name: "Asset Class", value: "asset_class", show: false },
        { name: "Portfolio Allocation Alternatives-INR", value: "alternatives_inr", show: false },
        { name: "Actual Portfolio Analysis", value: "actual_portfolio_analysis", show: false },

        { name: "List of all individual stock investments (get data from S1 S)", value: "individual_stock_investments", show: false },
        { name: "Sector Mix", value: "sector_mix", show: false },
        { name: "Market Cap Mix", value: "market_cap_mix", show: false },
        { name: "List of all individual MF investments", value: "individual_mf_investments", show: false },
        { name: "AMC Wise Exposure", value: "amc_wise_exposure", show: false },
        { name: "Fund Manager Wise Exposure", value: "fund_manager_wise_exposure", show: false },
        { name: "MF Portfolio Summary (current) - categorywise", value: "mf_portfolio_summary_categorywise", show: false },
        { name: "MF Portfolio Summary (current) - main categorywise", value: "mf_portfolio_summary_main_categorywise", show: false },
        { name: "Equity INR", value: "equity_inr", show: false },
        { name: "Debt INR", value: "debt_inr", show: false },
        { name: "Large cap INR", value: "large_cap", show: false },
        { name: "Hybrid Bifurcation", value: "hybrid_bifurcation", show: false },

        { name: "Stock Portfolio Report", value: "stock_portfolio_report", show: false },
        { name: "Mutual Fund Portfolio report", value: "mf_portfolio_report", show: false },
        { name: "Asset Class Outlook And Action", value: "asset_class_outlook_and_action", show: false },
        { name: "Actual Exposure", value: "actual_exposure", show: false }
      ],
      assetClassLblData: [
        { lbl: "Asset Class:", field: "asset_class_field" },
        { lbl: "INR", field: "INR" },
        { lbl: "%", field: "persentage" },
        //{ lbl: "% Without New Cash", field: "persentage_without_new_cash" },
        { lbl: "Investment horizon (years)", field: "investment_horizon_years" },
      ],
      assetClassTblData: [],
      indivStockInvestmentsLblData: [
        { lbl: "Name", field: "name_of_stock" },
        { lbl: "Sector", field: "sectorname" },
        { lbl: "MktCap (INR Cr)", field: "marketCapitalization_latest" },
        { lbl: "Mkt Cap type (SEBI Large/Mid/Small)", field: "industry_type" },
        { lbl: "Latest Value (INR)", field: "latest_value" },
        { lbl: "LV/Total (%)", field: "latest_value_per_all_values_of_company%" },
        /* { lbl: "LV/Total (%)", field: "lv_by_total_%" }, */
        { lbl: "P11", field: "business_score" },
        { lbl: "Qtrly", field: "p11_quarterly_trends_score" },
        { lbl: "Q1ab", field: "valuation_q1_a_S_or_q1_b_S" },
        { lbl: "z1", field: "z1_score" },
        { lbl: "Beta", field: "latest_beta" },
        { lbl: "Cash flow", field: "latest_free_cash_flow" },
        { lbl: "Actual EPS G % CAGR 5Yrs", field: "actual_eps_growth_cagr_5_years" },
        { lbl: "Actual Latest RoE", field: "actual_latest_roe" },
        { lbl: "Liquidity", field: "less_liquid_stock" },
      ],
      indivStockInvestmentsTblData: [],
      indivMFInvestmentsLblData: [
        { lbl: "Name", field: "sch_name" },
        { lbl: "Main Category", field: "MainCategory" },
        { lbl: "Category", field: "Category" },
        { lbl: "AMC", field: "Name_AMC" },
        { lbl: "Fund Mgr", field: "FundManager" },
        { lbl: "Latest Value (INR)", field: "latest_value" },
        { lbl: "LV/Total (%)", field: "latest_value_per_all_values_of_company%" },//field: "lv_by_total_%" 
        { lbl: "Recommended (Y/N)", field: "Recommended" },
        { lbl: "Overall Rating", field: "overall_scheme_rating" },
        { lbl: "Business Rating", field: "overall_business_rating" },
        { lbl: "Valuation Rating", field: "overall_valuation_rating" },
        { lbl: "Quarterly Rating", field: "overall_quarterly_rating" },
        { lbl: "Equity Rating", field: "overall_equity_rating" },
        { lbl: "Debt/Others Rating", field: "overall_debt_others_rating" },
        { lbl: "Large Cap holding%", field: "Large_Cap_holding%" },
        { lbl: "AAA holding %", field: "AAA_holding%" },
        { lbl: "Expense ratio%", field: "Expense_ratio%" },
        { lbl: "Duration (Yrs)", field: "Duration_Yrs" },
        { lbl: "Mean 1Y", field: "Mean_1Y" },
        { lbl: "Std Dev 1Yr", field: "Std_Dev_1Yr" },
        { lbl: "RR 1Yr (NAV > BSE 500)", field: "RR_1Yr_NAV_get_BSE_500" },
        { lbl: "RR 1Yr (NAV > BSE 500 Positive)", field: "RR_1Yr_NAV_BSE_500_Positive" },
        { lbl: "RR 1Yr (NAV < BSE 500 Negative)", field: "RR_1Yr_NAV_BSE_500_Negative" }
      ],
      indivMFInvestmentsTblData: [],
      hybridBifurcationLblData: [
        { lbl: "Name", field: "field_name" },
        { lbl: "Value", field: "value" }
      ],
      hybridBifurcationTblData: [],
      //indivStockInvestmentsLblData: [
      stockPortfolioReportLblData: [
        { lbl: "Number of stocks", field: "no_of_stocks", childFiled: "", hasChild: [] },
        { lbl: "Large cap holding", field: "large_cap_holding", childFiled: "", hasChild: [] },
        { lbl: "Top 3 holdings (Sum)", field: "top_3_holding", childFiled: "", hasChild: [] },
        { lbl: "Sector holding", field: "sector_holding", childFiled: "", hasChild: ['sectorname', 'latest_value_per_all_values_of_company'] },
        { lbl: "Top 3 holdings (stockwise) > 10%", field: "top_3_latest_value_per_all_values_of_company", childFiled: "", hasChild: ['name_of_stock', 'latest_value_per_all_values_of_company'] },
        { lbl: "<1% holdings", field: "latest_value_per_all_values_of_company_less_than_point_zero_one", childFiled: "", hasChild: ['name_of_stock', 'latest_value_per_all_values_of_company'] },
        { lbl: "Less liquid stocks", field: "Less_liquid_stocks", childFiled: "", hasChild: ['name_of_stock', 'less_liquid_stock'] },
        { lbl: "Small and microcap", field: "small_and_micro", childFiled: "", hasChild: [] },
        { lbl: "Overall rating", field: "portfolios_rating_value", childFiled: "overall_rating", hasChild: [] },
        { lbl: "Business rating", field: "portfolios_rating_value", childFiled: "business_rating", hasChild: [] },
        { lbl: "Valuation rating", field: "portfolios_rating_value", childFiled: "valuation_rating", hasChild: [] },
        { lbl: "Quarterly rating", field: "portfolios_rating_value", childFiled: "quarterly_rating", hasChild: [] },
        { lbl: "Beta>1", field: "latest_beta", childFiled: "", hasChild: ['name_of_stock', 'latest_beta'] }
      ],
      stockPortfolioReportTblData: [],
      mfPortfolioReportLblData: [
        { lbl: "Number of schemes", field: "number_of_schemes", filed1: "", hasChild: [] },
        { lbl: "Top scheme holding", field: "top_holdings", filed1: "Scheme", hasChild: ['sch_name', 'latest_value_by_total_value'] },
        { lbl: "Main category holding", field: "top_holdings", filed1: "MainCategory", hasChild: ['MainCategory', 'latest_value_by_total_value'] },
        { lbl: "Category holding", field: "top_holdings", filed1: "Category", hasChild: ['Category', 'latest_value_by_total_value'] },
        { lbl: "Equity", field: "user_allocation_portfolio_constructs", filed1: "equity_greater_than_60", hasChild: ['', 'equity_greater_than_60_value'] },
        { lbl: "Debt", field: "user_allocation_portfolio_constructs", filed1: "debt_less_than_40", hasChild: ['', 'debt_less_than_40_value'] },
        { lbl: "Sector holding", field: "user_allocation_portfolio_constructs", filed1: "sectors_greater_than_30", filed2: "sectors_greater_than_30", hasChild: ['sector_name', 'consol_perc_hldg'] },
        { lbl: "Foreign Equity", field: "user_allocation_portfolio_constructs", filed1: "foreign_equity_greater_than_40", hasChild: ['', 'foreign_equity_greater_than_40_value'] },
        { lbl: "Derivatives", field: "user_allocation_portfolio_constructs", filed1: "derivatives_greater_than_2", hasChild: ['', 'derivatives_greater_than_2_value'] },
        { lbl: "Gold", field: "user_allocation_portfolio_constructs", filed1: "gold_greater_than_5", hasChild: ['', 'gold_greater_than_5_value'] },
        { lbl: "Govt Sec / T bills/Reverse Repos", field: "user_allocation_portfolio_constructs", filed1: "gsec_tbill_rr_greater_than_10", hasChild: ['', 'gsec_tbill_rr_greater_than_10_value'] },
        { lbl: "ZCB", field: "user_allocation_portfolio_constructs", filed1: "zcb_greater_than_2", hasChild: ['', 'zcb_greater_than_2_value'] },
        { lbl: "Top 3 holdings (schemewise) > 10%", field: "top_3_scheme_holdings", filed1: "", hasChild: ['sch_name', 'total_returns_percent'] },
        { lbl: "Top 3 holdings (Sum)", field: "top_3_holding", filed1: "", hasChild: [] },
        { lbl: "<1% holdings", field: "less_than_1_percent_holdings", filed1: "", hasChild: [] },
        { lbl: "Beta > 1", field: "beta", filed1: "schemes", hasChild: ['sch_name', 'latest_value_by_total_value'] },
        { lbl: "Small and microcap", field: "small_cap_funds", filed1: "schemes", hasChild: ['sch_name', 'latest_value_by_total_value'] },
        { lbl: "Large cap Category holding", field: "large_cap_holding", filed1: "", hasChild: ['sch_name', 'lv_by_total_%'] },
        { lbl: "Overall rating", field: "overall_ratings", filed1: "overall_weighted_scheme_rating", hasChild: [] },
        { lbl: "Business rating", field: "overall_ratings", filed1: "overall_business_rating", hasChild: [] },
        { lbl: "Valuation rating", field: "overall_ratings", filed1: "overall_valuation_rating", hasChild: [] },
        { lbl: "Quarterly rating", field: "overall_ratings", filed1: "overall_quarterly_rating", hasChild: [] },
        { lbl: "Equity rating", field: "overall_ratings", filed1: "overall_equity_rating", hasChild: [] },
        { lbl: "Debt & Others rating", field: "overall_ratings", filed1: "overall_debt_others_rating", hasChild: [] }
      ],
      mfPortfolioReportLblTab2Data: [
        { lbl: "Number of schemes", field: "number_of_schemes", filed1: "", hasChild: [] },

        { lbl: "Top scheme holding", field: "top_holdings_scheme", filed1: "", hasChild: ['sch_name', 'latest_value_by_total_value'] },
        { lbl: "Category holding", field: "top_holdings_categorywise", filed1: "", hasChild: ['Category', 'latest_value_by_total_value'] },
        { lbl: "Main category holding", field: "top_holdings_maincategorywise", filed1: "", hasChild: ['MainCategory', 'latest_value_by_total_value'] },

        { lbl: "Equity", field: "equity_greater_than_60_value", filed1: "", hasChild: [] },
        { lbl: "Debt", field: "debt_less_than_40_value", filed1: "", hasChild: [] },
        { lbl: "Sector holding", field: "sectors_greater_than_30", filed1: "", hasChild: ['sector_name', 'consol_perc_hldg'] },
        { lbl: "Foreign Equity", field: "foreign_equity_greater_than_40_value", filed1: "", hasChild: [] },
        { lbl: "Derivatives", field: "derivatives_greater_than_2_value", filed1: "", hasChild: [] },
        { lbl: "Gold", field: "gold_greater_than_5_value", filed1: "", hasChild: [] },
        { lbl: "Govt Sec / T bills/Reverse Repos", field: "gsec_tbill_rr_greater_than_10_value", filed1: "", hasChild: [] },
        { lbl: "ZCB", field: "zcb_greater_than_2_value", filed1: "", hasChild: [] },

        { lbl: "Top 3 holdings (schemewise) > 10%", field: "top_3_scheme_holdings", filed1: "", hasChild: ['sch_name', 'latest_value_by_total_value'] },
        { lbl: "Top 3 holdings (Sum)", field: "top_3_holding", filed1: "", hasChild: [] },
        { lbl: "<1% holdings", field: "less_than_1_percent_holdings", filed1: "", hasChild: ['sch_name', 'latest_value_per_all_values_of_company'] },

        { lbl: "Beta > 1", field: "latest_beta", filed1: "", hasChild: ['sch_name', 'latest_beta'] },
        { lbl: "Small and microcap", field: "Small_and_micro_Cap_holding%", filed1: "", hasChild: [] },
        { lbl: "Large cap Category holding", field: "large_cap_holding", filed1: "", hasChild: ['sch_name', 'lv_by_total_%'] },

        { lbl: "Overall rating", field: "overall_ratings", filed1: "overall_scheme_rating", hasChild: [] },
        { lbl: "Business rating", field: "overall_ratings", filed1: "overall_business_rating", hasChild: [] },
        { lbl: "Valuation rating", field: "overall_ratings", filed1: "overall_valuation_rating", hasChild: [] },
        { lbl: "Quarterly rating", field: "overall_ratings", filed1: "overall_quarterly_rating", hasChild: [] },
        { lbl: "Equity rating", field: "overall_ratings", filed1: "overall_equity_rating", hasChild: [] },
        { lbl: "Debt & Others rating", field: "overall_ratings", filed1: "overall_debt_others_rating", hasChild: [] }
      ],
      mfPortfolioReportTblData: [],
      /* NEW DATA: END */
      firstInvestmentLblData: [{ lbl: "Financial instrument type", field: "financial_instrument_type" },
      { lbl: "Product knowledge", field: "product_knowledge" },
      { lbl: "Date of first investment", field: "date_of_first_investment" },
      { lbl: "Invested amount (INR)", field: "invested_amount_INR_cr" },
      { lbl: "Number of transactions", field: "mumber_of_transactions" }],
      aaaFrameworkLblData: [
        { lbl: "S No.", field: "S_No" },
        {
          lbl: "Assumption", field: "Assumption", child: [{ lbl: "Sub-Category", field: "sub_category" },
          { lbl: "Figure", field: "input_value" }]
        },
        { lbl: "Sub-Category", field: "sub_category" },
        { lbl: "Figure", field: "input_value" }],
      aaaFrameworkTblData: [],
      aaaTimeHorizonLblData: [
        { lbl: "S No.", field: "S_No" },
        { lbl: "Category", field: "Category" },
        { lbl: "Description", field: "Description" },
        { lbl: "Liquid", field: "Liquid" },
        { lbl: "Debt", field: "Debt" },
        { lbl: "Gold", field: "Gold" },
        { lbl: "Equity", field: "Equity" },
        { lbl: "Total", field: "Total" },
        { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
      ],
      aaaTimeHorizonTblData: [],
      aaaRiskProfileOfClientLblData: [
        { lbl: "S No.", field: "S_No" },
        { lbl: "Type of Investor", field: "Type_of_Investor" },
        { lbl: "Risk Profile", field: "Risk_Profile" },
        { lbl: "Liquid", field: "Liquid" },
        { lbl: "Debt", field: "Debt" },
        { lbl: "Gold", field: "Gold" },
        { lbl: "Equity", field: "Equity" },
        { lbl: "Total", field: "Total" },
        { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
      ],
      aaaRiskProfileOfClientTblData: [],
      aaaIncomeGenerationLblData: [
        { lbl: "S No.", field: "S_No" },
        { lbl: "Type of Corpus", field: "Type_of_Corpus" },
        { lbl: "When", field: "When" },
        { lbl: "Liquid", field: "Liquid" },
        { lbl: "Debt", field: "Debt" },
        { lbl: "Gold", field: "Gold" },
        { lbl: "Equity", field: "Equity" },
        { lbl: "Total", field: "Total" },
        { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
      ],
      aaaIncomeGenerationTblData: [],
      aaaRecommendationToClientLblData: [
        { lbl: "S No.", field: "S_No" },
        { lbl: "Investment Portfolio Name", field: "Investment_Portfolio_Name" },
        { lbl: "Liquid", field: "Liquid" },
        { lbl: "Debt", field: "Debt" },
        { lbl: "Gold", field: "Gold" },
        { lbl: "Equity", field: "Equity" },
        { lbl: "Total", field: "Total" },
        { lbl: "Portfolio Returns", field: "Portfolio_Returns" }
      ],
      aaaRecommendationToClientTblData: [],
      outlookAndActionLblData: [
        { lbl: "Asset class outlook and action:", field: "field_name" },
        { lbl: "Outlook", field: "outlook" },
        { lbl: "Action", field: "action" },
        { lbl: "Rationale", field: "rationale" }
      ],
      outlookAndActionTblData: [],
      allocationAlternativesInrLblData: [
        { lbl: "Alternatives", field: "asset_class_field" },
        { lbl: "INR", field: "INR" },
        { lbl: "%", field: "persentage" }
      ],
      allocationAlternativesInrTblData: [],
      desiredMixAlternativesLblData: [
        { lbl: "Alternatives", field: "desired_asset_field" },
        { lbl: "Desired Mix %", field: "%_Mix" }
      ],
      desiredMixAlternativesTblData: [],
      desireAssetAllocationLblData: [
        { lbl: "Desired Asset Allocation (Client)", field: "desired_asset_field" },
        { lbl: "Desired Mix %", field: "%_Mix" }
      ],
      desireAssetAllocationTblData: [],
      /* ALL TABLE IN ONE API : Start */
      actualPortfolioAnalysisLblData: [
        { lbl: "Stock Portfolio Value", field: "stock_portfolio_value", col1: "stock_portfolio_value", col2: "stock_portfolio_value_manual" },
        { lbl: "MF Portfolio Value", field: "mutual_fund_portfolio_value", col1: "mutual_fund_portfolio_value", col2: "mutual_fund_portfolio_value_manual" },
        { lbl: "Total Portfolio Value (INR)", field: "total_portfolio_value_INR", col1: "total_portfolio_value_INR", col2: "total_portfolio_value_INR_manual" },
        { lbl: "Investment horizon (years) - weighted", field: "investment_horizon_years_weighted", col1: "investment_horizon_years_weighted", col2: "investment_horizon_years_weighted_manual" },
        { lbl: "New Cash available", field: "new_cash_available", col1: "new_cash_available", col2: "new_cash_available_manual" }
      ],
      equityInrLblData: [
        { lbl: "Stock portfolio total", field: "stock_portfolio_value" },
        { lbl: "Mutual funds equity incl hybrid total", field: "mutual_funds_equity_incl_hybrid_total" }
        /* { lbl: "%", field: "%" } */
      ],
      debtInrLblData: [
        { lbl: "Mutual Funds - Debt", field: "Mutual_Funds_Debt", sub_field: "mutual_funds_debt_incl_hybrid_total" },
        { lbl: "Fixed Deposits", field: "Fixed_Deposits", sub_field: "Fixed_Deposits_total" },
        { lbl: "Others", field: "Others", sub_field: "Others_total" }
      ],
      largeCapLblData: [
        { lbl: "Large cap stocks", field: "Large_cap_stocks", sub_field: "large_cap_stocks_total" },
        { lbl: "Large cap MFs", field: "Large_cap_MFs", sub_field: "Large_cap_MFs_total" }
      ],
      actualExposureLblData: [
        { lbl: "Total Portfolio Value", field: "Total_Portfolio_Value", name: "", third_field: "%", sub_field: "" },
        { lbl: "Total Equity Portfolio", field: "Total_Equity_Portfolio", name: "", third_field: "%", sub_field: "Total_Equity_Portfolio" },
        { lbl: "Large cap", field: "Large_cap", name: "", third_field: "%", sub_field: "Large_cap" },
        { lbl: "Total Debt Portfolio", field: "Total_Debt_Portfolio", name: "", third_field: "%", sub_field: "Total_Debt_Portfolio" },
        { lbl: "Liquid", field: "Liquid", name: "", third_field: "%", sub_field: "Liquid_total" },
        { lbl: "Gold", field: "Gold", name: "", third_field: "%", sub_field: "gold_total" },
        { lbl: "Alternatives", field: "Alternatives", name: "", third_field: "%", sub_field: "alternative_total" },
        { lbl: "Real Estate", field: "Real_Estate", name: "", third_field: "%", sub_field: "real_estate_total" },
        { lbl: "AAA debt", field: "AAA_debt", name: "", third_field: "%", sub_field: "total_AAA_debt" },
        { lbl: "Total Portfolio Value", field: "Total_Portfolio", name: "", third_field: "%", sub_field: "" },
        { lbl: "Actual liquidity (in 3 days)", field: "Actua_liquidity_in_3_days", name: "", third_field: "%", sub_field: "total_Actua_liquidity_in_3_days_value" },
        { lbl: "Duration", field: "Duration", name: "sch_name", third_field: "Duration_Yrs", sub_field: "latest_value" },
        { lbl: "Highest sector exposure", field: "Highest_sector_exposure", name: "sectorname", third_field: "latest_value_per_all_values_of_company", sub_field: "amount" },
        { lbl: "MF scheme exposure highest", field: "MF_scheme_exposure_highest", name: "sch_name", third_field: "lv_by_total_%", sub_field: "latest_value" },
        { lbl: "Stock exposure highest", field: "Stock_exposure_highest", name: "name_of_stock", third_field: "lv_by_total_%", sub_field: "latest_value" },
        { lbl: "Expense ratio actual", field: "Expense_ratio_actual", name: "sch_name", third_field: "lv_by_total_%", sub_field: "latest_value" },
        { lbl: "High Yield Bonds exposure", field: "High_Yield_Bonds_exposure", name: "", third_field: "%", sub_field: "High_Yield_Bonds_exposure" },
        { lbl: "AMC exposure", field: "AMC_exposure", name: "Name_AMC", third_field: "latest_value_per_all_values_of_company", sub_field: "Total_latest_value" },
        { lbl: "AIF exposure", field: "AIF_exposure", name: "", third_field: "%", sub_field: "AIF_exposure" },
        { lbl: "PMS exposure", field: "PMS_exposure", name: "", third_field: "%", sub_field: "PMS_exposure" },
        { lbl: "Overseas", field: "Overseas", name: "", third_field: "%", sub_field: "Overseas" },
        { lbl: "<1 year portfolio (Debt+FD+Liquid)", field: "lt_1_year_portfolio_Debt_FD_Liquid", name: "", third_field: "%", sub_field: "total_lt_1_year_portfolio_Debt_FD_Liquid" },
        { lbl: ">5 year portfolio", field: "gt_5_year_portfolio", name: "", third_field: "%", sub_field: "gt_5_year_portfolio" }
      ],
      userProfileAllocationReportAllTblData: [],
      /* ALL TABLE IN ONE API : End */

    };
  },
  methods: {
    reset() {

    },
    desireAssetAllocationTotal(data) {
      let total = 0;
      data.map((item) => {
        total += parseFloat(item['%_Mix']);
      });
      return total;
    },
    individualStockInstPerCalc(data) {
      let calc = 0;
      data.map((item) => {
        calc += parseFloat(item['lv_by_total_%']) * 100;
      });
      return calc;
    },
    userPortfolioAnalysis() {
      let self = this;
      try {
        self.$router.push({
          name: "user-portfolio-analysis",
          params: { id: self.userId },
          query: { tab: self.curTabIndex }
        });
      } catch (error) {

      }
    },
    convertPerOfEquity(data) {
      //console.log('data', data.stock_portfolio_value['%'], data.mutual_funds_equity_incl_hybrid_total['%']);
      return ((data.stock_portfolio_value['%'] + data.mutual_funds_equity_incl_hybrid_total['%']) * 100) + '%';
    },
    convertPerOfDebt(data) {
      return ((data.Mutual_Funds_Debt['%'] + data.Fixed_Deposits['%'] + data.Others['%']) * 100) + '%';
    },
    convertPerOfLargeCap(data) {
      return ((data.Large_cap_stocks['%'] + data.Large_cap_MFs['%']) * 100) + '%';
    },
    benchmarkTabShow(obj) {
      const desc = '•' + obj.user_field + ' - ' + obj.answer + '\n•' + obj.title + ' - ' + obj.calculation_response;
      return desc;
    },
    formatDate(date) {
      console.log('formatDate', this.getDate(date));
      return this.getDate(date);
    },
    selectDate(date, pIdx, field) {
      //console.log('selectDate', this.getDate(date));
      this.firstInvestmentTblData[0].data[pIdx].date_of_first_investment = String(this.getDate(date));
      console.log('key', String(field));
      //console.log('pData', pData);
      console.log('firstInvestmentTblData[0].data >>> ', this.firstInvestmentTblData[0].data[pIdx].date_of_first_investment)
      /* const strKey = String(key)
      console.log('with pData', pData[strKey]);
      pData.date_of_first_investment = this.getDate(date); */
      //return this.getDate(date);
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log('Tab:::', tabIndex, 'newTab:', newTab.title, 'oldTab:', oldTab.title);

      let self = this;
      self.curTab = newTab.title;
      self.curTabIndex = tabIndex;

      this.mfPortfolioReportTblData = {};

      if (newTab.title !== oldTab.title) {

        if (self.isIntFirstTime === false) {
          try {
            self.$router.push({
              name: "user-portfolio-allocation",
              params: { id: self.userId },
              query: { tab: self.curTabIndex }
            });
          } catch (error) {

          }
        }

        this.getPortfolioAllocationData();
        this.getDesireAssetAllocationAPI();
        this.getAssetClassAPI();
        this.getAlternativesInrAPI();
        this.getDesiredMixAlternativesAPI();
        //For all table in one api
        this.getUserProfileAllocationReportAllAPI();
        //For all table in one api
        this.getIndivStockInvestmentsAPI();
        this.getIndivMFInvestmentsAPI();
        this.getOutlookAndActionAPI();

        if (this.curTab == 'Zero New Cash') {
          this.getStockPortfolioReportAPI();
          this.getMfPortfolioReportAPI();
        }
      }
      self.isIntFirstTime = false;
    },
    otherTabsShow(key) {
      //this.otherTabs[key] = !this.otherTabs[key];
    },
    answerFun(evt, index, cIdx) {
      //console.log('answer:', typeof (evt));
      //console.log('answer:', evt);
      if (evt != null) {
        if (typeof (evt) == 'object') {
          //console.log(evt.value);
          //ans = evt.value;
          this.usersStrategyForm.data[index].data[cIdx].answer = evt.value ? evt.value : "";
        }
      } else {
        this.usersStrategyForm.data[index].data[cIdx].answer = "";
      }
    },
    showDetails(tabs) {
      tabs.show = !tabs.show;
      //tabs
      //this.usersStrategyForm.data[idx].show = !this.usersStrategyForm.data[idx].show;
      //console.log('this.usersStrategyForm', this.usersStrategyForm.data);
    },
    /*-------------------------------------*/
    /* Portfolio Allocation Reference: START */
    /*-------------------------------------*/
    getPortfolioAllocationData(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      http.post("/frontend/portfolio_allocation_fields_for_reference/get", paramData, (error, response) => {
        if (response.status === 'success') {

          console.log('getPortfolioAllocationData => ', response.data);
          if (response.data.length === 0) {
            //self.ifIsBlank = true;
            //self.getPortfolioAllocationData(true);
            self.userPortfolioAllocationData = [{ "data": [] }];
            //self.getStrategyData();
          } else {
            //self.ifIsBlank = false;
            self.userPortfolioAllocationData = response.data;
          }
        }
      });
    },
    submitPortfolioAllocationData() {
      let self = this;
      console.log('userPortfolioAllocationData >>>', self.userPortfolioAllocationData);
      //----------------------
      /* const obj = this.assetClassTblData;
      console.log('assetClassTblData: ', obj);
      let notValid = false;
      obj[0].data.map((item) => {
        if (String(item.taxation_status).trim() == "" || String(item.taxation_status).trim() == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      } */
      //----------------------

      if (self.userPortfolioAllocationData.length > 0) {
        if (!self.userPortfolioAllocationData[0].client_id) {
          self.userPortfolioAllocationData[0].client_id = self.userId;
        }
        delete self.userPortfolioAllocationData[0]._id;
        delete self.userPortfolioAllocationData[0].data;
      } else {
        self.$toastr.error("Something went wrong.", "", {});
        return;
      }
      /* let paramData = {};
      paramData = {
        "client_id": self.userId,
        "data": obj[0].data
      } */

      http.post("/frontend/portfolio_allocation_fields_for_reference/update", self.userPortfolioAllocationData[0], (error, response) => {
        if (response.responseType === 'success') {
          console.log('res data', response.data);
          self.$toastr.success(response.msg, "", {});
        }
      });
    },
    /*-------------------------------------*/
    /* Portfolio Allocation Reference: END */
    /*-------------------------------------*/

    /*-------------------------------------------*/
    /* Portfolio Allocation Asset Class : START */
    /*------------------------------------------*/
    getAssetClassAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      let selTabs = "";
      if (self.curTab == 'Zero New Cash') {
        selTabs = "?zero_cash=1"
      } else if (self.curTab == 'With New Cash') {
        selTabs = "?new_cash=1";
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        selTabs = "?new_cash_portfolio=1";
      }
      http.post(`/frontend/portfolio_allocation_asset_class/get${selTabs}`, paramData, (error, response) => {
        console.log('### getAssetClassAPI >> ', response);
        if (response != null) {
          if (response.status === 'success') {
            if (response.data.length === 0) {
              self.getAssetClassAPI(true);
            } else {
              self.assetClassTblData = response.data;
              if (self.assetClassTblData.length > 0) {
                self.assetClassTblData[0].data.map((item) => {
                  const str = String(item.asset_class_field).toLowerCase();
                  if (str.indexOf("new cash available") === 0) {
                    self.nCashAvailableVal = item.INR;
                  }
                });
              }
            }
          }
        }
      });
    },
    submitAssetClassAPI(bypass = false) {
      let self = this;
      const obj = this.assetClassTblData;
      console.log('assetClassTblData: ', obj);
      let notValid = false;
      obj[0].data.map((item) => {
        //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
        if (item.asset_class_field == "" || item.INR == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid && bypass === false) {
        self.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "data": obj[0].data
      }

      if (obj.length === 0) {
        self.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submitAssetClassAPI >>> ', paramData);
        let selTabs = "";//&new_cash=1 / &new_cash_portfolio=1 / &zero_cash=1

        if (self.curTab == 'Zero New Cash') {
          selTabs = "&zero_cash=1"
        } else if (self.curTab == 'With New Cash') {
          selTabs = "&new_cash=1";
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          selTabs = "&new_cash_portfolio=1";
        }
        //return;
        http.post(`/frontend/portfolio_allocation_asset_class/update?new_cash_update=1${selTabs}`, paramData, function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getAssetClassAPI();

            if (bypass) {
              self.getPortfolioAllocationData();
              self.getDesireAssetAllocationAPI();
              self.getAlternativesInrAPI();
              self.getDesiredMixAlternativesAPI();
              //For all table in one api
              self.getUserProfileAllocationReportAllAPI();
              //For all table in one api
              self.getIndivStockInvestmentsAPI();
              self.getIndivMFInvestmentsAPI();
              self.getOutlookAndActionAPI();

              if (self.curTab == 'Zero New Cash') {
                self.getStockPortfolioReportAPI();
                self.getMfPortfolioReportAPI();
              }
            }
          } else if (response.responseType === "fail") {
            self.$toastr.error(response.msg, "", {});
          }
          //self.isNew = false;
          //self.isShow = false;
        });
      }
    },
    /*----------------------------------------*/
    /* Portfolio Allocation Asset Class : END */
    /*----------------------------------------*/

    /*---------------------------*/
    /* Alternatives- INR : START */
    /*---------------------------*/
    getAlternativesInrAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }
      let selTabs = "";

      if (self.curTab == 'Zero New Cash') {
        selTabs = "?zero_cash=1"
      } else if (self.curTab == 'With New Cash') {
        selTabs = "?new_cash=1";
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        selTabs = "?new_cash_portfolio=1";
      }

      http.post(`/frontend/portfolio_allocation_alternatives/get${selTabs}`, paramData, (error, response) => {
        if (response.status === 'success') {
          //self.allocationAlternativesInrTblData = response.data;
          if (response.data.length === 0) {
            self.getAlternativesInrAPI(true);
          } else {
            self.allocationAlternativesInrTblData = response.data;
          }

        }
      });
    },
    submitAlternativesInrAPI() {
      let self = this;
      const obj = this.allocationAlternativesInrTblData;//this.hybridBifurcationTblData;
      console.log('obj', obj);
      let notValid = false;
      obj[0].data.map((item) => {
        //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
        if (item.asset_class_field.trim() == "" || item.INR.trim() == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let paramData = obj[0].client_id ? obj[0] : {};

      if (!obj[0].client_id) {
        paramData = {
          "client_id": self.userId,
          "data": obj[0].data
        }
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        delete paramData._id;
        console.log('submit >>> ', paramData);

        let selTabs = "";
        if (self.curTab == 'Zero New Cash') {
          selTabs = "&zero_cash=1"
        } else if (self.curTab == 'With New Cash') {
          selTabs = "&new_cash=1";
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          selTabs = "&new_cash_portfolio=1";
        }
        //return;
        http.post(`/frontend/portfolio_allocation_alternatives/update?new_cash_update=1${selTabs}`, paramData, function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getAlternativesInrAPI();
            self.getAssetClassAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /*-------------------------*/
    /* Alternatives- INR : END */
    /*-------------------------*/

    /*--------------------------------------------------*/
    /* User Profile Allocation Report All TABLE : START */
    /*--------------------------------------------------*/
    getUserProfileAllocationReportAllAPI() {
      let self = this;

      let paramData = {
        "client_id": self.userId
      }

      let apiURL = "/frontend/user_porofile_allocation_report_table/get";
      if (self.curTab === 'With New Cash') {
        apiURL = "/frontend/user_porofile_allocation_report_table_with_new_cash_update/get";
      } else if (self.curTab === 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/user_porofile_allocation_report_table_with_new_cash_and_portfolio_update/get";
      }

      http.post(apiURL, paramData, (error, response) => {
        console.log('$$$$##### ', response);
        if (response.status === 'success') {
          self.userProfileAllocationReportAllTblData = response.data == null ? [] : response.data;

          if (self.curTab === 'With New Cash' || self.curTab === 'With New Cash and Portfolio Changes') {
            self.stockPortfolioReportTblData = [];
            self.mfPortfolioReportTblData = [];
            if (self.userProfileAllocationReportAllTblData.length !== 0) {
              self.stockPortfolioReportTblData = self.userProfileAllocationReportAllTblData.stock_portfolio_reports;
              self.mfPortfolioReportTblData = self.userProfileAllocationReportAllTblData.Mutual_Fund_Portfolio_report;
            }
            console.log('1 ### ', self.curTab, self.userProfileAllocationReportAllTblData);
          }

          console.log('$$$$1 ', self.stockPortfolioReportTblData);
          console.log('$$$$2 ', self.mfPortfolioReportTblData);
          if (self.stockPortfolioReportTblData == undefined) {
            self.stockPortfolioReportTblData = [];
          }
          if (self.mfPortfolioReportTblData == undefined) {
            self.mfPortfolioReportTblData = {};
          }
        }
      });
    },
    submitUserProfileAllocationReportAllAPI() {
      let self = this;
      const obj = this.userProfileAllocationReportAllTblData;
      //console.log('obj', obj);
      //return;
      let notValid = false;
      /* if (String(obj.actual_portfolio_analysis.stock_portfolio_value).trim() == "" || String(obj.actual_portfolio_analysis.mutual_fund_portfolio_value).trim() == "" || String(obj.actual_portfolio_analysis.total_portfolio_value_INR).trim() == "" || String(obj.actual_portfolio_analysis.investment_horizon_years_weighted).trim() == "" || String(obj.actual_portfolio_analysis.new_cash_available).trim() == "") {
        notValid = true;
      } */
      /*obj[0].data.map((item) => {
         if (item.desired_asset_field.trim() == "" || item['%_Mix'].trim() == "") {
           notValid = true;
         }
      }); */
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let paramData = obj.client_id ? obj : {};

      if (!obj.client_id) {
        paramData = {
          "client_id": self.userId,
          "data": obj.data
        }
      }

      if (paramData._id) {
        delete paramData._id;
      }


      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('### SUBMIT >>> ', paramData);

        let selTabs = "";
        if (self.curTab == 'Zero New Cash') {
          selTabs = "&zero_cash=1"
        } else if (self.curTab == 'With New Cash') {
          selTabs = "&new_cash=1";
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          selTabs = "&new_cash_portfolio=1";
        }
        //return;
        http.post(`/frontend/user_porofile_allocation_report_table/update?user_update=1${selTabs}`, paramData, function (error, response) {
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getUserProfileAllocationReportAllAPI();
          } else if (response.responseType === "fail") {
            self.$toastr.error(response.msg, "", {});
          }
          //self.isNew = false;
          //self.isShow = false;
        });
      }
    },
    /*------------------------------------------------*/
    /* User Profile Allocation Report All TABLE : END */
    /*------------------------------------------------*/



    /*----------------------------------*/
    /* Desired Mix Alternatives : START */
    /*----------------------------------*/
    getDesiredMixAlternativesAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      http.post("/frontend/desired_alternatives_allocation_client/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length === 0) {
            self.getDesiredMixAlternativesAPI(true);
          } else {
            self.desiredMixAlternativesTblData = response.data;
          }
        }
      });
    },
    submitDesiredMixAlternativesAPI() {
      let self = this;
      const obj = this.desiredMixAlternativesTblData;
      console.log('obj', obj);
      let notValid = false;
      obj[0].data.map((item) => {
        if (item.desired_asset_field.trim() == "" || item['%_Mix'].trim() == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let paramData = obj[0].client_id ? obj[0] : {};

      if (!obj[0].client_id) {
        paramData = {
          "client_id": self.userId,
          "data": obj[0].data
        }
      }

      if (paramData._id) {
        delete paramData._id;
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submit >>> ', paramData);
        //return;
        http.post("/frontend/desired_alternatives_allocation_client/update", paramData, function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getDesiredMixAlternativesAPI();
          } else if (response.responseType === "fail") {
            self.$toastr.error(response.msg, "", {});
          }
          //self.isNew = false;
          //self.isShow = false;
        });
      }
    },
    /*--------------------------------*/
    /* Desired Mix Alternatives : END */
    /*-------------------------------*/


    /*----------------------------------------*/
    /* Desire Asset Allocation-Client : START */
    /*----------------------------------------*/
    getDesireAssetAllocationAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      http.post("/frontend/desired_asset_allocation_client/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length === 0) {
            self.getDesireAssetAllocationAPI(true);
          } else {
            self.desireAssetAllocationTblData = response.data;
          }

        }
      });
    },
    submitDesireAssetAllocationAPI() {
      let self = this;
      const obj = this.desireAssetAllocationTblData;
      console.log('obj', obj);
      let notValid = false;
      obj[0].data.map((item) => {
        if (item.desired_asset_field.trim() == "" || item['%_Mix'].trim() == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let paramData = obj[0].client_id ? obj[0] : {};

      if (!obj[0].client_id) {
        paramData = {
          "client_id": self.userId,
          "data": obj[0].data
        }
      }

      if (paramData._id) {
        delete paramData._id;
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submit >>> ', paramData);
        //return;
        http.post("/frontend/desired_asset_allocation_client/update", paramData, function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getDesireAssetAllocationAPI();
          } else if (response.responseType === "fail") {
            self.$toastr.error(response.msg, "", {});
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /*--------------------------------------*/
    /* Desire Asset Allocation-Client : END */
    /*--------------------------------------*/

    /*-----------------------------*/
    /* Outlook and Action  : START */
    /*-----------------------------*/
    getOutlookAndActionAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      http.post("/frontend/profile_allocation_asset_class_outlook_and_action/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length === 0) {
            self.getOutlookAndActionAPI(true);
          } else {
            self.outlookAndActionTblData = response.data;
          }
        }
      });
    },
    submitOutlookAndActionAPI() {
      let self = this;
      const obj = this.outlookAndActionTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        //console.log('###=> ', item.financial_instrument_type, item.product_knowledge)             
        if (item.outlook.trim() == "" || item.action.trim() == "" || item.rationale.trim() == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "data": obj[0].data
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submitOutlookAndActionAPI >>> ', paramData);
        //return;
        http.post("/frontend/profile_allocation_asset_class_outlook_and_action/update", paramData, function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getOutlookAndActionAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /*---------------------------*/
    /* Outlook and Action  : END */
    /*---------------------------*/


    /*--------------------------------*/
    /* stock_portfolio_report : START */
    /*--------------------------------*/
    getStockPortfolioReportAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      http.post("/frontend/stock_portfolio_report/get", paramData, (error, response) => {
        if (response != null) {
          if (response.status === 'success') {
            if (response.data.length === 0) {
              self.getStockPortfolioReportAPI(true);
            } else {
              self.stockPortfolioReportTblData = {};
              self.stockPortfolioReportTblData = response.data;
            }
          }
        }
      });
    },
    submitStockPortfolioReportAPI() {
      let self = this;
      const obj = this.stockPortfolioReportTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        if (item.outlook.trim() == "" || item.action.trim() == "" || item.rationale.trim() == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "data": obj[0].data
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('Submit >>> ', obj[0]);
        return;
        http.post("/frontend/stock_portfolio_report/update", obj[0], function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getStockPortfolioReportAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /*------------------------------*/
    /* stock_portfolio_report : END */
    /*------------------------------*/

    /*--------------------------------------*/
    /* Mutual_Fund_Portfolio_report : START */
    /*--------------------------------------*/
    //getStockPortfolioReportAPI(flg = false) {
    getMfPortfolioReportAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      http.post("/frontend/Mutual_Fund_Portfolio_report/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length === 0) {
            self.getMfPortfolioReportAPI(true);
          } else {
            self.mfPortfolioReportTblData = {};
            self.mfPortfolioReportTblData = response.data;
            console.log('2 ### ', self.curTab, self.mfPortfolioReportTblData);
            console.log('mfPortfolioReportTblData >>>', self.mfPortfolioReportTblData)
          }
        }
      });
    },
    submitMfPortfolioReportAPI() {
      let self = this;
      const obj = this.mfPortfolioReportTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        if (item.outlook.trim() == "" || item.action.trim() == "" || item.rationale.trim() == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      let paramData = {};
      paramData = {
        "client_id": self.userId,
        "data": obj[0].data
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('Submit >>> ', obj[0]);
        return;
        http.post("/frontend/Mutual_Fund_Portfolio_report/update", obj[0], function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getMfPortfolioReportAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    },
    /*------------------------------------*/
    /* Mutual_Fund_Portfolio_report : END */
    /*------------------------------------*/


    /*-------------------------------------*/
    /* Individual Stock Investment : START */
    /*-------------------------------------*/
    getIndivStockInvestmentsAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }
      let apiURL = "";
      if (self.curTab == 'Zero New Cash') {
        apiURL = "/frontend/list_of_all_individual_stock_investments/get";
      } else if (self.curTab == 'With New Cash' || self.curTab == 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/profile_allocation_list_of_all_individual_stock_investments_with_s1s/get";
        if (self.curTab == 'With New Cash') {
          paramData.collection_name = 'with_new_cash';
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          paramData.collection_name = 'with_new_cash_portfolio';
        }
      }
      console.log('Stock apiURL:', apiURL);
      http.post(apiURL, paramData, (error, response) => {
        if (response != null) {
          if (response.status === 'success') {
            console.log('getAssetClassAPI >> ', response.data);
            self.indivStockInvestmentsTblData = response.data;
          }
        }
      });
    },
    submitIndivStockInvestmentsAPI(idx) {
      let self = this;

      if (confirm("Are you sure you want to delete this item?") == true) {
        self.indivStockInvestmentsTblData.List_of_all_individual_stock_investments.splice(idx, 1);
        //self.submitCalculationLimitAPI();
      } else {
        return;
      }

      let paramData = self.indivStockInvestmentsTblData;
      delete paramData.total_latest_value;
      delete paramData.total_latest_value_pr;

      let apiURL = "";
      if (self.curTab == 'Zero New Cash') {
        //apiURL = "/frontend/list_of_all_individual_stock_investments/update";
        apiURL = "/frontend/profile_allocation_list_of_all_individual_stock_investments/update";
      } else if (self.curTab == 'With New Cash' || self.curTab == 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/profile_allocation_list_of_all_individual_stock_investments_with_s1s/update";
        if (self.curTab == 'With New Cash') {
          paramData.collection_name = 'with_new_cash';
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          paramData.collection_name = 'with_new_cash_portfolio';
        }
      }
      console.log('Submit apiURL:', apiURL);
      console.log('paramData', paramData);
      //self.indivStockInvestmentsTblData.List_of_all_individual_stock_investments
      //console.log('idx', idx);
      //return;
      http.post(apiURL, paramData, (error, response) => {

        console.log('#### submitIndivStockInvestmentsAPI >> ', response.status);
        if (response.status === 'success') {
          self.$toastr.success("Update Success...!", "", {});
          self.getIndivStockInvestmentsAPI();
          /* self.indivStockInvestmentsTblData = [];
          self.indivStockInvestmentsTblData = response.data; */
        }
      });
    },
    /*-------------------------------------*/
    /* Individual Stock Investment : END */
    /*-------------------------------------*/
    /*----------------------------------*/
    /* Individual MF Investment : START */
    /*----------------------------------*/
    getIndivMFInvestmentsAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      let apiURL = "";
      if (self.curTab == 'Zero New Cash') {
        apiURL = "/frontend/list_of_all_individual_MF_investments/get";
      } else if (self.curTab == 'With New Cash' || self.curTab == 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/profile_allocation_list_of_all_individual_MF_investments_with_recommended/get";
        if (self.curTab == 'With New Cash') {
          paramData.collection_name = 'with_new_cash';
        } else if (self.curTab == 'With New Cash and Portfolio Changes') {
          paramData.collection_name = 'with_new_cash_portfolio';
        }
      }

      console.log(">>>> self.curTab: ", self.curTab, "apiURL: ", apiURL);

      http.post(apiURL, paramData, (error, response) => {
        console.log('response >> ', response)
        if (response != null) {
          if (response.status === 'success') {
            console.log('getIndivMFInvestmentsAPI >> ', response.data);
            if (response.data.length === 0) {
              self.getIndivMFInvestmentsAPI(true);
            } else {
              self.indivMFInvestmentsTblData = response.data;
            }
          }
        }
      });
    },
    submitIndivMFInvestmentsAPI(idx) {
      let self = this;

      if (confirm("Are you sure you want to delete this item?") == true) {
        self.indivMFInvestmentsTblData.List_of_all_individual_MF_investments.splice(idx, 1);
      } else {
        return;
      }

      let paramData = self.indivMFInvestmentsTblData;
      delete paramData.total_latest_value;
      delete paramData.total_latest_value_pr;

      let apiURL = "";
      if (self.curTab == 'Zero New Cash') {
        apiURL = "/frontend/list_of_all_individual_MF_investments/update";
      } else if (self.curTab == 'With New Cash' || self.curTab == 'With New Cash and Portfolio Changes') {
        apiURL = "/frontend/profile_allocation_list_of_all_individual_MF_investments_with_recommended/update";
      }
      console.log('Submit apiURL:', apiURL);
      console.log('paramData', paramData);
      //return;
      http.post(apiURL, paramData, (error, response) => {
        console.log('#### submitIndivMFInvestmentsAPI >> ', response.status);
        if (response.status === 'success') {
          self.$toastr.success("Update Success...!", "", {});
          self.getIndivMFInvestmentsAPI();
        }
      });
    },
    /*--------------------------------*/
    /* Individual MF Investment : END */
    /*--------------------------------*/

    /*--------------------------*/
    /* Update Cron Data : START */
    /*--------------------------*/
    updateCronData() {
      let self = this;

      let paramData = { "client_id": self.userId };
      let updateCronURL = "/frontend/user_portfolio_profile_analysis_allocation/update";

      if (self.curTab == 'Zero New Cash') {
        paramData.collection_name = 'without_new_cash';
      } else if (self.curTab == 'With New Cash') {
        paramData.collection_name = 'with_new_cash';
      } else if (self.curTab == 'With New Cash and Portfolio Changes') {
        paramData.collection_name = 'with_new_cash_portfolio';
      }

      console.log('updateCronURL:', updateCronURL, 'paramData: ', paramData)
      //return;
      http.post(updateCronURL, paramData, (error, response) => {
        console.log('updateCronData : response:', response);
        if (response.responseType === 'success') {
          self.$toastr.success(response.msg, "", {});
        }
      });
    },
    /*------------------------*/
    /* Update Cron Data : END */
    /*------------------------*/
    nCaseAvailableSubmit() {
      let self = this;
      let notValid = false;
      console.log('nCashAvailableVal >>>', self.nCashAvailableVal);
      console.log('assetClassTblData >>>', self.assetClassTblData);
      if (self.assetClassTblData.length > 0) {
        let collectedObj = { data: [], _id: self.assetClassTblData[0]._id };
        self.assetClassTblData[0].data.map((item) => {
          const str = String(item.asset_class_field).toLowerCase();
          //console.log('item ==> ', Object.keys(item));
          if (str.indexOf("new cash available") === 0) {
            item.INR = self.nCashAvailableVal;
          }
        });
      }
      if (String(self.nCashAvailableVal).trim() == "") {
        notValid = true;
      }
      if (notValid) {
        this.$toastr.error("New Cash Available field filled required. !", "", {});
        return;
      }
      self.submitAssetClassAPI(true);
    },

    /*--------------------------------*/
    /* Hybrid Bifurcation  : START */
    /*--------------------------------*/
    /* getHybridBifurcationAPI(flg = false) {
      let self = this;
      let paramData = {};
      if (flg) {
        paramData = {};
      } else {
        paramData = {
          "client_id": self.userId
        }
      }

      http.post("/frontend/hybrid_bifurcation_table/get", paramData, (error, response) => {
        if (response.status === 'success') {
          if (response.data.length === 0) {
            self.getHybridBifurcationAPI(true);
          } else {
            self.hybridBifurcationTblData = response.data;
          }
        }
      });
    },
    submitHybridBifurcationAPI() {
      let self = this;
      const obj = this.hybridBifurcationTblData;
      let notValid = false;
      obj[0].data.map((item) => {
        if (item.field_name.trim() == "" || item.value.trim() == "") {
          notValid = true;
        }
      });
      console.log('notValid:', notValid);
      if (notValid) {
        this.$toastr.error("All form fields filled required !", "", {});
        return;
      }

      if (obj.length === 0) {
        this.$toastr.error("All fields filled required.", "", {});
      } else {
        console.log('submit >>> ', obj[0]);
        //return;
        http.post("/frontend/hybrid_bifurcation_table/update", obj[0], function (error, response) {
          //console.log(">>>> post data:", response);
          if (response.responseType === "success") {
            self.$toastr.success(response.msg, "", {});
            self.getHybridBifurcationAPI();
          }
          self.isNew = false;
          self.isShow = false;
        });
      }
    }, */
    /*---------------------------*/
    /* Hybrid Bifurcation  : END */
    /*---------------------------*/

  }
};
</script>
<style>
.table {
  font-size: 0.925em;
}

/* .vdp-datepicker input{
  font-size: small !important;
  background-color: white !important;
} */

.table td {
  padding: 4px 10px 4px 10px !important;
}

.table-xirr {
  width: auto;
}

.txt-area {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.form-cs-n {
  border: 1px solid #c4c2c2;
  padding: 13px;
  /* padding-bottom: 0; */
  border-radius: 7px;
  background-color: #f5faff;
}

.date-pik {
  background-color: white !important;
  /* height: 1.8rem; */
  font-size: x-small;
}

/* .vdp-datepicker__calendar {
  position: fixed;
  top: auto;
} */
.form-z .vdp-datepicker {
  position: initial !important;
}

.time-horizon-cs {
  padding: 0px 4px 0px 4px !important;
}

.v-select {
  width: 100%;
  margin-left: 10px;
}

.txt-fmt {
  font-size: small;
}

.dropdown-menu {
  font-size: small;
}

.new-tbl-cs {
  appearance: none;
  border: 1px solid rgba(60, 60, 60, .26);
  border-radius: 4px;
  white-space: normal;
  height: 1.5rem;
  width: 100%;
  height: 1.9rem;
  padding: 0 6px;
}

.new-tbl-aaa-cs {
  appearance: none;
  border: 1px solid rgba(60, 60, 60, .26);
  border-radius: 4px;
  white-space: normal;
  height: 1.5rem;
  width: 100%;
  height: 1.9rem;
  padding: 0 6px;
  margin: 3px 0 3px;
}

.user-profiling label {
  margin-bottom: 0;
  font-weight: normal;
}

.n-input-fl {
  border: 1px solid #bebebe;
  width: fit-content;
  padding: 7px;
  margin-left: 15px;
  border-radius: 7px;
  margin-bottom: 10px;
  vertical-align: middle;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/user-portfolio-allocation.vue